
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DataDictionaryDialog extends Serenity.EntityDialog<DataDictionaryRow, any> {
        protected getFormKey() { return DataDictionaryForm.formKey; }
        protected getIdProperty() { return DataDictionaryRow.idProperty; }
        protected getLocalTextPrefix() { return DataDictionaryRow.localTextPrefix; }
        protected getNameProperty() { return DataDictionaryRow.nameProperty; }
        protected getService() { return DataDictionaryService.baseUrl; }

        protected form = new DataDictionaryForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            return buttons;
        }
    }
}